import { IUpdateFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/update/update_funcionario_treinamento_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";




export class UpdateFuncionarioTreinamentoUseCase implements IUpdateFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async updateFuncionarioTreinamento(
    idFuncionarioTreinamento: number,
    idTreinamento: number,
    cargaHoraria: number,
    local: string,
    instrutor: string,
    dataRealização: Date,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.repository.updateFuncionarioTreinamento(
      idFuncionarioTreinamento,
      idTreinamento,
      cargaHoraria,
      dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    );
  }
}